<template>
	<div>
		<div class="address-finder-wrapper">
			<address-finder-input
				:value="value.full_address"
				:label="label"
				:required="!showManualAddressFields && addressFieldsMissing"
				:addressFieldsMissing="addressFieldsMissing"
				@input="(newValue) => update('full_address', newValue)"
				@selected="populateAddressFields"
			/>

			<a
				href="#"
				class="manual-address-toggle"
				@click.prevent="showManualAddressFields = !showManualAddressFields"
				v-if="!showManualAddressFields"
				>Can't find your address? Click here to enter it manually.</a
			>
		</div>

		<!-- Manual address entry fields -->
		<transition name="slide">
			<div class="manual-address-entry-fields" v-if="showManualAddressFields">
				<text-input
					label="Address 1"
					:value="value.street"
					@input="(newValue) => update('street', newValue)"
				></text-input>

				<text-input
					label="Address 2"
					:value="value.address1"
					:required="false"
					@input="(newValue) => update('address1', newValue)"
				></text-input>

				<div class="row">
					<div class="col-md-12">
						<text-input
							label="Suburb"
							:value="value.suburb"
							@input="(newValue) => update('suburb', newValue)"
						></text-input>
					</div>
				</div>

				<div class="row">
					<div class="col-md-6">
						<text-input
							label="City"
							:value="value.city"
							@input="(newValue) => update('city', newValue)"
						></text-input>
					</div>
					<div class="col-md-6">
						<text-input
							label="Postcode"
							:value="value.postcode"
							@input="(newValue) => update('postcode', newValue)"
						></text-input>
					</div>
				</div>

				<div class="form-group">
					<text-input
						label="Country"
						:value="value.country"
						@input="(newValue) => update('country', newValue)"
					></text-input>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import Vue from 'vue';
import formControlProps from '../Mixins/formControlProps';
import validationProps from '../Mixins/validationProps';
import textInput from './TextInput';
import addressFinderInput from './AddressFinderInput';

export default {
	mixins: [formControlProps, validationProps],

	props: {
		// https://simonkollross.de/posts/vuejs-using-v-model-with-objects-for-custom-components
		value: Object,
	},

	data() {
		return {
			showManualAddressFields: typeof MANUAL_ADDRESS !== 'undefined' ? true : false
		};
	},

	methods: {
		// Emit a new object containing the single property value change
		update(key, value) {
			this.$emit('input', { ...this.value, [key]: value });
		},

		// Emit a new object containing all the address fields from AddressFinder
		populateAddressFields(address) {
			this.$emit('input', {
				...this.value,
				full_address: address.fullAddress,
				street: address.address_line_1(),
				address1: address.address_line_2(),
				suburb: address.suburb(),
				city: address.city(),
				postcode: address.postcode(),
				country: 'New Zealand',
			});

			// The values won't be updated until the next tick
			Vue.nextTick(() => {
				if (this.addressFieldsMissing) {
					this.showManualAddressFields = true;
				}
			});
		}
	},

	computed: {
		// Determine if any required address fields are missing
		addressFieldsMissing() {
			return (
				!this.value.street ||
				!this.value.suburb ||
				!this.value.city ||
				!this.value.postcode ||
				!this.value.country
			);
		}
	},

	components: {
		textInput,
		addressFinderInput,
	},
};
</script>
